module.exports = __webpack_public_path__ + "img/section-3-content_6_img.4bb8cd7a.png";